import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import LandingPage from './pages/LandingPage';
import { LANDING_PAGES } from './pages/landingConfigs';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/amazon-ppc-agency"
            element={<LandingPage config={LANDING_PAGES.amazonPpcAgency} source="amazon-ppc-agency" />}
          />
          <Route
            path="/amazon-ads-agency-usa"
            element={<LandingPage config={LANDING_PAGES.amazonAdsAgencyUsa} source="amazon-ads-agency-usa" />}
          />
          <Route
            path="/amazon-ads-agency-canada"
            element={<LandingPage config={LANDING_PAGES.amazonAdsAgencyCanada} source="amazon-ads-agency-canada" />}
          />
          <Route
            path="/best-amazon-ppc-agency"
            element={<LandingPage config={LANDING_PAGES.bestAmazonPpcAgency} source="best-amazon-ppc-agency" />}
          />
          <Route
            path="/amazon-ppc-agency-north-america"
            element={<LandingPage config={LANDING_PAGES.amazonPpcAgencyNorthAmerica} source="amazon-ppc-agency-north-america" />}
          />
          <Route
            path="/amazon-consulting-services"
            element={<LandingPage config={LANDING_PAGES.amazonConsultingServices} source="amazon-consulting-services" />}
          />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
